<template>
    <div class="">
        <div class="hover:cursor-pointer" v-on:click="openMenu()">
            <slot name="trigger"></slot>
        </div>

        <teleport to="body">
            <div
                v-show="showMenu"
                :class="
                    'fixed left-0 right-0 top-0 z-40 flex h-full items-center justify-center bg-black/10' +
                    ' ' +
                    cssClasses
                "
                @click.self="closeMenu()"
            >
                <div
                    :class="
                        'absolute top-0 z-50 h-full bg-white shadow' +
                        ' ' +
                        (openFrom + '-0')
                    "
                    :style="'width:' + pxWidth + 'px'"
                >
                    <div
                        class="absolute right-4 top-4 -mt-2 p-2 hover:cursor-pointer"
                        @click="closeMenu()"
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M18 6L6 18"
                                stroke="#84929A"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M6 6L18 18"
                                stroke="#84929A"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                    <slot name="menu_content" />
                </div>
            </div>
        </teleport>
    </div>
</template>
<script>
import { Inertia } from "@inertiajs/inertia";

export default {
    name: "slide-over-menu",
    data() {
        return {
            showMenu: false,
        };
    },
    props: {
        startOpen: {
            type: Boolean,
            default: false,
        },
        openFrom: {
            type: String,
            default: "left",
        },
        pxWidth: {
            type: Number,
            default: 300,
        },
        cssClasses: {
            type: String,
            default: "",
        },
    },
    methods: {
        openMenu() {
            this.showMenu = true;
        },
        closeMenu() {
            this.showMenu = false;
        },
    },
    mounted() {
        if (this.startOpen) {
            this.showMenu = true;
        } else {
            Inertia.on("navigate", (event) => {
                this.showMenu = false;
            });
        }
    },
};
</script>
